import React, { memo, useState } from "react";
import Icon from "./Icons/Icon";
import "./LogInWithImage.scss";

function LogInWithImage(props) {
  const {
    doLogin,
    onChange,
    title,
    description,
    loginWithTitle,
    email,
    isMonitorLoginEnabled,
    loginOptions,
    backgroundImage,
    brandLogo,
    brandLogoLeftPanel,
    welcomeLabel = "Welcome!",
    welcomeSubLabel = "",
    onShowPasswordChange,
    showPassword,
    rememberMe,
    onRememberMeChange,
    isCopyRightText = false,
    copyrightText = "",
    hideForgotPassword,
    forgotPassword,
    forgotPasswordView,
    sendPasswordLink,
    backgroundImageOverlayColor,
    backgroundImageOverlayColorOpacity,
  } = props;

  const DISCLAIMER_STORAGE_KEY = "dataGovernanceConsentDate";
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [pendingLogin, setPendingLogin] = useState(null);

  const getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleNormalLogin = () => {
    if (hasAcceptedDisclaimerToday()) {
      doLogin();
      return;
    }
    setPendingLogin({
      type: "NORMAL",
    });
    setIsConsentChecked(false);
    setShowDisclaimer(true);
  };

  const handleSSOLogin = (e, option) => {
    e.preventDefault();
    if (hasAcceptedDisclaimerToday()) {
      window.location.href = option.uri;
      return;
    }
    setPendingLogin({
      type: "SSO",
      uri: option.uri,
    });
    setIsConsentChecked(false);
    setShowDisclaimer(true);
  };

  const hasAcceptedDisclaimerToday = () => {
    return (
      localStorage.getItem(DISCLAIMER_STORAGE_KEY) ===
      getTodayDate()
    );
  };

  const handleAcceptDisclaimer = () => {
    if (!isConsentChecked || !pendingLogin) {
      return;
    }
    localStorage.setItem(
      DISCLAIMER_STORAGE_KEY,
      getTodayDate()
    );
    const loginToContinue = pendingLogin;
    setShowDisclaimer(false);
    setIsConsentChecked(false);
    setPendingLogin(null);
    if (loginToContinue.type === "NORMAL") {
      doLogin();
      return;
    }
    if (
      loginToContinue.type === "SSO" &&
      loginToContinue.uri
    ) {
      window.location.href = loginToContinue.uri;
    }
  };

  const handleDeclineDisclaimer = () => {
    setShowDisclaimer(false);
    setIsConsentChecked(false);
    setPendingLogin(null);
  };

  const backgroundStyle = {};
  if (backgroundImage) {
    backgroundStyle.backgroundImage = `url(${backgroundImage})`;
  }
  const backgroundOverlayStyle = {
    backgroundColor: backgroundImageOverlayColor ? backgroundImageOverlayColor : "transparent",
    opacity: backgroundImageOverlayColorOpacity ? backgroundImageOverlayColorOpacity : 1,
    width: "100%",
    height: "100%",
  };

  const logo = brandLogo || "/img/logos/accenture-logo.svg";
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // doLogin();
      handleNormalLogin();
    }
  };

  return (
    <div className="axiom-login-with-image">
      <div className="login-data-container">
        {brandLogoLeftPanel && (
          <div className="left-panel-login-brand-logo">
            <img src={brandLogoLeftPanel} className="image-login-logo" />
          </div>
        )}
        <div className="image-login-header">{welcomeLabel}</div>
        {welcomeSubLabel && <div className="image-login-subheader">{welcomeSubLabel}</div>}
        <div className="image-login-content">
          {isMonitorLoginEnabled && (<>
            {isMonitorLoginEnabled && forgotPasswordView ? (
              <>
                <div>
                  <div className="image-login-label">Email ID</div>
                  <div className="image-login-box">
                    <div className="image-login-input-logo">
                      <Icon icon={"ICON_USER"} className={"image-login-icon"} />
                    </div>
                    <div className="image-login-input-box">
                      <input
                        type={"text"}
                        className={"image-login-input"}
                        placeholder={"Enter your email address"}
                        autoFocus={true}
                        onKeyPress={handleKeyPress}
                        onChange={(e) => onChange("email", e)}
                        value={email}
                      />
                    </div>
                  </div>
                </div>
                <div tabIndex={0} className="image-login-btn" onClick={sendPasswordLink}>
                  SUBMIT
                </div>
                <a tabIndex={0} className="login-form-forgot-password" onClick={forgotPassword}>
                  Back to Login
                </a>
              </>
            ) : (
              <div>
                <div>
                  <div className="image-login-label">Email ID</div>
                  <div className="image-login-box">
                    <div className="image-login-input-logo">
                      <Icon icon={"ICON_USER"} className={"image-login-icon"} />
                    </div>
                    <div className="image-login-input-box">
                      <input
                        type={"text"}
                        className={"image-login-input"}
                        placeholder={"Username"}
                        autoFocus={true}
                        onKeyPress={handleKeyPress}
                        onChange={(e) => onChange("email", e)}
                        value={email}
                      />
                    </div>
                  </div>
                  <div className="image-login-label">Password</div>
                  <div className="image-login-box">
                    <div className="image-login-input-logo">
                      <Icon icon={"ICON_PASSWORD"} className={"image-login-icon"} />
                    </div>
                    <div className="image-login-input-box">
                      <input
                        type={showPassword ? "text" : "password"}
                        className={"image-login-input"}
                        placeholder={"Password"}
                        onKeyPress={handleKeyPress}
                        onChange={(e) => onChange("password", e)}
                      />
                      <label
                        className={"image-login-remember-me-label"}
                        onClick={() => onShowPasswordChange()}
                        tabIndex={0}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </label>
                    </div>
                  </div>
                  <div className="image-login-rememberme">
                    <div>
                      <input
                        type="checkbox"
                        className="image-login-rememberme-checkbox"
                        onChange={() => onRememberMeChange()}
                        defaultChecked={rememberMe}
                        id="image-login-rememberme-checkbox"
                      />
                      <label
                        tabIndex={0}
                        htmlFor="image-login-rememberme-checkbox"
                        className={"image-rememberme-label"}
                      >
                        Remember Me
                      </label>
                    </div>
                    {!hideForgotPassword && (
                      <a href="#" className="login-form-forgot-password" onClick={forgotPassword}>
                        Forgot Password?
                      </a>
                    )}
                  </div>
                </div>
                <div
                  tabIndex={0}
                  aria-roledescription="button"
                  className="image-login-btn"
                  // onClick={doLogin}
                  onClick={handleNormalLogin}
                >
                  LOG IN
                </div>
              </div>
            )}
            {loginOptions && loginOptions.length > 0 && <div className="image-login-or-text">OR</div>}
          </>)}
          {loginOptions && loginOptions.length > 0 && (
            <div className="image-login-other">
              <div className="image-other-login-text">Login with {loginWithTitle}</div>
              <div className="other-login-form-option-wrapper">
                {loginOptions.map((option, index) => {
                  return (
                    <a className="login-form-option" href={option.uri} key={index} onClick={(e) => handleSSOLogin(e, option)}>
                      <img className="login-form-option-icon" src={option.logo} />
                    </a>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {isCopyRightText.toString() == "true" ? (
        <div className="copyright-login-bottom-container">{copyrightText}</div>
      ) : null}
      {showDisclaimer && (
        <div className="governance-consent-overlay" role="presentation">
          <div className="governance-consent-modal" role="dialog" aria-modal="true"
            aria-labelledby="governance-consent-title">

            <div className="governance-consent-header">
              <div className="governance-consent-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3L4.5 6V11.5C4.5 16.1 7.7 20.2 12 21.3C16.3 20.2 19.5 16.1 19.5 11.5V6L12 3Z"
                    stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                  <path d="M9 12L11 14L15.5 9.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </div>
              <div className="governance-consent-heading">
                <h2 id="governance-consent-title">
                  Data Governance & Confidentiality Consent
                </h2>
                <p>
                  Please review and acknowledge the following requirements
                  before continuing.
                </p>
              </div>
            </div>

            <div className="governance-consent-body">
              <section className="governance-section">
                <div className="governance-section-title">
                  Declaration & Consent
                </div>
                <p className="governance-intro">
                  By logging into and using this application, I acknowledge and
                  agree that:
                </p>
                <ul className="governance-consent-list">
                  <li>
                    The information, reports, customer data, financial records,
                    and other banking information accessible through this
                    application are confidential and proprietary to the Bank.
                  </li>
                  <li>
                    I will access and use data strictly for authorized business
                    purposes and within the scope of my assigned role and
                    responsibilities.
                  </li>
                  <li>
                    I will not copy, download, share, transmit, disclose, or
                    distribute any customer or banking data to unauthorized
                    individuals, systems, external parties, or personal
                    devices.
                  </li>
                  <li>
                    I will comply with all applicable Data Governance,
                    Information Security, Privacy, and Regulatory policies of
                    the Bank.
                  </li>
                  <li>
                    I understand that customer information is sensitive and
                    must be protected from unauthorized access, misuse,
                    modification, or disclosure.
                  </li>
                  <li>
                    I will immediately report any suspected security incident,
                    data breach, unauthorized access, or misuse of information.
                  </li>
                  <li>
                    I acknowledge that all activities performed within this
                    application, including data access, queries, downloads, and
                    report generation, may be logged, monitored, and audited by
                    the Bank.
                  </li>
                  <li>
                    I understand that any misuse of banking data, customer
                    information, or system access may result in disciplinary
                    action, access revocation, legal proceedings, and
                    regulatory consequences.
                  </li>
                  <li>
                    I understand that my queries and activities are monitored
                    and can be tracked.
                  </li>
                </ul>
              </section>
              <section className="governance-user-consent">
                <div className="governance-user-consent-title">
                  User Consent
                </div>
                <label className="governance-checkbox-wrapper">
                  <input type="checkbox" checked={isConsentChecked} onChange={(e) =>
                    setIsConsentChecked(e.target.checked)
                  }
                  />
                  <span className="governance-custom-checkbox">
                    <svg viewBox="0 0 12 10">
                      <path d="M1 5L4.3 8.2L11 1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="governance-checkbox-text">
                    I have read, understood, and agree to comply with the
                    Bank&apos;s Data Governance, Information Security, and
                    Confidentiality requirements. I undertake not to misuse any
                    banking data, customer information, or confidential
                    business information accessed through this application.
                  </span>
                </label>
                <p className="governance-consent-note">
                  By clicking <strong>Accept & Continue</strong>, I provide my
                  consent to the above terms and conditions.
                </p>
              </section>
            </div>

            <div className="governance-consent-footer">
              <button type="button" className="governance-decline-button" onClick={handleDeclineDisclaimer}>
                Decline
              </button>
              <button type="button" className="governance-accept-button" disabled={!isConsentChecked}
                onClick={handleAcceptDisclaimer}>
                Accept & Continue
                <svg viewBox="0 0 20 20" fill="none">
                  <path d="M4 10H16M11 5L16 10L11 15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={backgroundStyle} className="login-image-container">
        <div style={backgroundOverlayStyle}>
          <div className="login-brand-logo">
            <img src={logo} className="image-login-logo" />
          </div>
          <div className="login-brand-text">
            <div className="login-brand-title">{title}</div>
            <div className="login-brand-description">{description}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(LogInWithImage);
